;(function () {
    CopyTextToClipboard = function (params = {}) {
        this.copyBtn = params.copyBtn || null;
        this.text = params.text || '';
        this.successMessage = params.successMessage || null;
        this.successMessageView = params.successMessageView || null;
        this.init();
    };

    CopyTextToClipboard.prototype.init = function () {
        if (this.copyBtn !== null) {
            this.initClickCopyTextToClipboard();
        }
    };

    CopyTextToClipboard.prototype.setValue = function (value) {
        this.text = value;
        this.successMessageView = this.successMessage + this.text;
    };

    CopyTextToClipboard.prototype.initClickCopyTextToClipboard = function () {
        const copyBtn = this.copyBtn;

        if (!this.text) {
            this.text = copyBtn.querySelector('[data-type="copy-value"]').textContent;
        }

        this.successMessageView = this.successMessage + this.text;
        if(copyBtn) {
            copyBtn.addEventListener('click', function (e) {
                this.copyTextToClipboard(this.text);
            }.bind(this));
        }
    };

    CopyTextToClipboard.prototype.fallbackCopyTextToClipboard = function (text) {
        const range = document.createRange();
        const hideNode = BX.create('div', {
            text: text,
            style: {position: "absolute", width: 0}
        });
        document.body.appendChild(hideNode);
        range.selectNode(hideNode);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        document.body.removeChild(hideNode);
    };

    CopyTextToClipboard.prototype.copyTextToClipboard = async function (text) {
        if (navigator.clipboard) {
            await navigator.clipboard.writeText(text);
            this.execEventAfterCopy(text);
            return;
        }

        try {
            this.fallbackCopyTextToClipboard(text);
            this.execEventAfterCopy(text);
        } catch (e) {
            console.error('Unable to copy text');
        }
    };

    CopyTextToClipboard.prototype.execEventAfterCopy = function (text) {
        BX.onCustomEvent('B2BNotification',[
            this.successMessageView,
            'success'
        ]);
    };
}());